import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { ProfilMenuItem } from '../profilMenuItem';
import { ProfilMenuInfo } from '../profilMenuInfo';
import { AppBarSearch } from './appBarSearch';
import { ResetLayoutButton } from './resetLayoutButton';
import { FitToScreenButton } from './fitToScreenButton';
import { AddButton } from './AppBar/addButton';
import { MoreButton } from './AppBar/moreButton';
import { useState, useEffect, useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { AppBarLogo } from '../Home/AppBarLogo';
import { Container, Tooltip } from '@mui/material/node';
import { ShowCommentsButton } from './AppBar/showCommentsButton';
import { ShowElementsViewButton } from './AppBar/showElementsViewButton';
import { AuthContext } from '../../contexts/authContext';
import { ShareProjectButton } from './AppBar/shareProjectButton';
import {Button} from '@mui/material';

// Default sign-in button component
const SignInButton = () => (
  <Button 
    href="/login" 
    variant="contained" 
    color="primary" 
    sx={{ borderRadius: 20, height: 35, minWidth: 82}}
  >Sign In
    
  </Button>
);

export const MyProjectAppBar = (props) => {
  const { user, userProfile, loading, profileLoading } = useContext(AuthContext);
  const [userProfileComponent, setUserProfileComponent] = useState(<SignInButton />);
  const theme = useTheme();

  
  // Update user profile based on authentication state
  useEffect(() => {
    if (loading || profileLoading) return;
    
    if (user && userProfile) {
      const profileDataWithEmail = {
        ...userProfile,
        email: user.email,
        uid: user.uid,
      };
      setUserProfileComponent(<ProfilMenuItem userData={profileDataWithEmail} />);
    } else {
      setUserProfileComponent(<SignInButton />);
    }
  }, [user, loading, userProfile, profileLoading]);
  
  return (
    <Box sx={{ flexGrow: 1, backgroundColor: theme.palette.appBarBg.main }}>
      <AppBar position="static" sx={{ bgcolor: theme.palette.appBarBg.main, boxShadow: "none" }}>
        <Toolbar>
          {!((props.ispublic === true) || (props.ispublic === 'true')) &&
            <Tooltip title="Project Settings">
              <IconButton
                size="small"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 1 }}
                onClick={() => { props.setProjectDrawerState(true) }}
              >
                <MenuIcon sx={{ color: theme.palette.menuIcon.main }} />
              </IconButton>
            </Tooltip>
          }
          <AppBarLogo style={{ marginRight: "10px" }} isMobile={props.isMobile} />
          {!props.isMobile &&
            <Container></Container>
          }
          <AppBarSearch
            elements={props.elements}
            canvasRef={props.canvasRef}
            filterOptions={{
              excludeGroups: ["edges"], // Exclude edges from search
              namePattern: "" // Optional: filter by name pattern
            }}
          />
          {!props.isMobile && <>
            <ResetLayoutButton action={() => props.canvasRef.current.setLayout()} />
            <FitToScreenButton action={() => props.canvasRef.current.Fit()} />
          </>
          }
          {!((props.ispublic === true) || (props.ispublic === 'true')) &&
            <AddButton selectedItem={props.selectedItem} canvasRef={props.canvasRef} />
          }
          <ShowCommentsButton></ShowCommentsButton>
          {!((props.ispublic === true) || (props.ispublic === 'true')) &&
            <ShowElementsViewButton canvasRef={props.canvasRef}></ShowElementsViewButton>
          }
          {((props.ispublic === true) || (props.ispublic === 'true')) &&
            <ShareProjectButton canvasRef={props.canvasRef}></ShareProjectButton>
          }
          <MoreButton
            selectedItem={props.selectedItem}
            canvasRef={props.canvasRef}
            isMobile={props.isMobile}
            actionResetLayout={() => props.canvasRef.current.setLayout()}
            actionFitToScreen={() => props.canvasRef.current.Fit()}
          />
          {/* {((props.ispublic === true) || (props.ispublic === 'true')) &&
            <ProfilMenuInfo userData={props.publicUserInfo} projectData={props.projectData}></ProfilMenuInfo>
          }
          {!((props.ispublic === true) || (props.ispublic === 'true')) &&
            <ProfilMenuItem userData={userProfile}></ProfilMenuItem>
          } */}
          {userProfileComponent}
        </Toolbar>
      </AppBar>
    </Box>
  );
}